// extracted by mini-css-extract-plugin
export default {"title":"Title_title__GrXs1","line":"Title_line__aqaKU"};